export default "__VITE_ASSET__VusFmBUJ__";